import React, { useEffect, useState } from 'react'
import { Link } from 'react-router-dom'
import { fetchListItems } from '../../../hooks/useCrud';
import DOMPurify from 'dompurify';
import GoogleTranslate from '../../../components/GoogleTranslate';
import GoogleTranslate2 from '../../../components/GoogleTranslate2';
import logoApp from '../../../assets/logos/logo_swift_ride_green.png';
import FooterGalery from '../Components/Sections/about/FooterGalery';
import { fileUrl } from '../../../api/config';

interface Site {
    id?: number;
    nom?: string;
    description?: string;
    email?: string;
    adresse?: string;
    tel1?: string;
    tel2?: string;
    tel3?: string;
    token?: string;
    about?: string;
    mission?: string;
    objectif?: string;
    politique?: string;
    condition?: string;
    logo?: string;
    logoFile?: File;
    facebook?: string;
    linkedin?: string;
    twitter?: string;
    youtube?: string;
    whatsapp?: string;
    createdAt?: string;
    updatedAt?: string;
}
interface UiCatBlog {
    id?: number;
    titre?: string;
    slug?: string;
    createdAt?: string;
    updatedAt?: string;
}

export default function FooterPage() {
    const [sites, setSites] = useState<Site[]>([]);
    const [categories, setCategories] = useState<UiCatBlog[]>([]);
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState<string | null>(null);
    const fetchListCategorie = async () => {
        setLoading(true);
        try {
            const res = await fetchListItems<UiCatBlog>('/fetch_category_blog_data');
            setCategories(res.data);

            // console.log(res);
        } finally {
            setLoading(false);
        }

    }

    const fetchData = async () => {
        setLoading(true);
        try {
            const res = await fetchListItems<Site>('/fetch_data_site');
            setSites(res.data);

            // console.log(res);
        } finally {
            setLoading(false);
        }

    }

    useEffect(() => {
        fetchData();
        fetchListCategorie();
    }, []);

    return (

        <footer id="uc-footer" className="uc-footer panel uc-dark">
            <div className="footer-outer py-4 lg:py-6 xl:py-9 bg-white dark:bg-gray-900">
                <div className="container max-w-xl">
                    <div className="footer-inner vstack gap-4 justify-center lg:fs-5 text-gray-900 dark:text-white">
                        {
                            sites.map((item, index) => (
                                <div className="footer-logo text-center" key={index}>

                                    <img className="uc-logo w-100px text-gray-900 dark:text-white" src={`${fileUrl}/images/${item.logo ?? 'avatar.png'}`} alt="Diocèse de Goma" data-uc-svg />
                                </div>
                            ))
                        }

                        <nav className="footer-nav">
                            <ul className="nav-x gap-2 lg:gap-3 justify-center text-center fw-medium">
                                {
                                    categories.map((item, index) => (

                                        <li key={index} className='hover:text-opacity-70 dark:hover:text-white duration-150'><Link to={'/category/' + item.slug}>{item.titre} </Link></li>
                                    ))
                                }

                            </ul>
                        </nav>
                        <div className="footer-social hstack justify-center gap-2 lg:gap-3">
                            {
                                sites.map((item, index) => (


                                    <ul className="nav-x gap-2" key={index}>


                                        <li>
                                            <a className="hover:text-gray-900 dark:hover:text-white duration-150" href={item.facebook} target="_blank">
                                                <i className="icon fa-brands fa-facebook"></i>
                                            </a>
                                        </li>
                                        <li>
                                            <a className="hover:text-gray-900 dark:hover:text-white duration-150" href={item.twitter} target="_blank">
                                                <i className="icon fa-brands fa-x-twitter"></i>
                                            </a>
                                        </li>
                                        <li>
                                            <a className="hover:text-gray-900 dark:hover:text-white duration-150" href={item.linkedin} target="_blank">
                                                <i className="icon fa-brands fa-linkedin"></i>
                                            </a>
                                        </li>
                                        <li>
                                            <a className="hover:text-gray-900 dark:hover:text-white duration-150" href={item.youtube} target="_blank">
                                                <i className="icon fa-brands fa-youtube"></i>
                                            </a>
                                        </li>
                                    </ul>

                                ))
                            }
                            <div className="vr"></div>
                            <div className="d-inline-block">
                                {/* <a href="#" className="hstack gap-1 text-none fw-medium">
                                    <i className="icon icon-1 fas fa-globe"></i>
                                    <span>Français</span>
                                    <span data-uc-drop-parent-icon=""></span>
                                </a>
                                <div className="p-2 bg-white dark:bg-gray-800 shadow-xs w-150px" data-uc-drop="mode: click; boundary: !.uc-footer-bottom; animation: uc-animation-slide-top-small; duration: 150;">
                                    <ul className="nav-y gap-1 fw-medium items-end">
                                        <li><a href="#fr">Français</a></li>
                                        <li><a href="#sw">Kiswahili</a></li>
                                        <li><a href="#ln">Lingala</a></li>
                                        <li><a href="#en">English</a></li>
                                    </ul>
                                </div> */}

                                <div className="d-inline-block bg-daark">
                                    <div id="google_translate_element"></div>
                                </div>
                            </div>
                        </div>
                        <div className="footer-contact text-center">
                            {
                                sites.map((item, index) => (
                                    <div className="hstack gap-3 justify-center fs-6" key={index}>
                                        <div className="vstack gap-1">
                                            <i className="fas fa-map-marker-alt text-primary"></i>
                                            <span className="fs-7">{item.adresse}</span>
                                        </div>
                                        <div className="vr"></div>
                                        <div className="vstack gap-1">
                                            <i className="fas fa-phone text-primary"></i>
                                            <span className="fs-7">{item.tel1}</span>
                                        </div>
                                        <div className="vr"></div>
                                        <div className="vstack gap-1">
                                            <i className="fas fa-envelope text-primary"></i>
                                            <span className="fs-7">{item.email}</span>
                                        </div>
                                    </div>
                                ))
                            }
                        </div>
                        <div className="footer-copyright vstack sm:hstack justify-center items-center gap-1 lg:gap-2">
                            <p>Ouragan Academy © {new Date().getFullYear()}, Tous droits réservés.</p>
                            <ul className="nav-x gap-2 fw-medium">
                                <li><Link className="uc-link  hover:text-gray-900 dark:hover:text-white duration-150" to="/confidentialite">Politique de confidentialité</Link></li>
                                <li><Link className="uc-link  hover:text-gray-900 dark:hover:text-white duration-150" to="/mentions-legales">Mentions légales</Link></li>
                                <li><Link className="uc-link  hover:text-gray-900 dark:hover:text-white duration-150" to="/contact">Contact</Link></li>
                            </ul>
                        </div>
                    </div>
                </div>
            </div>
        </footer>

    )
}
